<script setup lang="ts">
import GraveyardPlaceLanding from "@/components/graveyard/GraveyardPlaceLanding.vue";

definePage({
  meta: {
    navActiveLink: "graveyard-graves",
    permissionKey: "page.graveyard.graves",
  },
});
</script>

<template>
  <GraveyardPlaceLanding />
</template>
